// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".learn-more[data-v-9ed334b6]{font-weight:bolder;text-decoration:none}.popover[data-v-9ed334b6]{z-index:2000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
